import {Button, Form, Input, Select} from "antd";
import "../../../styles/component/user/userCreate.scss";
import React, {useEffect, useState} from "react";
import {User_type} from "../../../constant/constant";
import toastify from "../../../common/toastify";
import {useNavigate} from "react-router-dom";
import {getName} from "../../../utility/utility";
import resources from "../../../resources";
import server from "../../../server";

const UserCreate = (props: any) => {
    const [isFormEmpty, setIsFormEmpty] = useState<boolean>(true);
    const userTypesEnum = Object.values(User_type);
    const [form] = Form.useForm();
    const {initialData, mode, onModalClose, userData, setUserData} = props;
    const navigate = useNavigate();
    const tempResources = resources.usersCreate
    const tempResourcesButton = resources.commonButtonText;

    useEffect(() => {
        if (initialData) {
            form.setFieldsValue(initialData);
        }
        window.history.pushState(null, '', window.location.href);
        window.onpopstate = function (event) {
            window.history.go(1);
        };
    }, [initialData, form]);

    const onFinish = async (values: any) => {
        try {
            let currentFormValues = {...values};
            const payload = {
                "name": {
                    "firstName": values.firstName,
                    "middleName": values.middleName,
                    "lastName": values.lastName,
                },
                "email": values.email,
                "roles": values.roles.map((role: any) => role.toUpperCase()),
            }

            if (mode === "create") {
                const response = await server.user.create(payload);
                const id = response.split('/');
                values['id'] = id[id.length - 1];
                currentFormValues['id'] = id[id.length - 1];
                currentFormValues['status'] = 'InActive';
                currentFormValues['name'] = getName(currentFormValues.firstName, currentFormValues.middleName ?? '', currentFormValues.lastName ?? '');
                setUserData([...userData, {...currentFormValues}]);
                if (payload.roles.includes("EMPLOYEE")) {
                    navigate('/user/create-success', {
                        replace: true,
                        state: {record: values}
                    });
                } else
                    toastify({title: 'Success', message: 'User created successfully', isSuccessful: true});
            } else if (mode === "edit" && initialData?.id) {
                await server.user.update({
                    ...payload,
                    id: initialData.id,
                    employeeId: initialData.employeeId
                }, initialData.id);
                const editableUserIndex = userData.findIndex((user: any) => {
                    return initialData.id === user.id
                });
                const updatedUser = {...userData[editableUserIndex], ...currentFormValues};
                userData.splice(editableUserIndex, 1, updatedUser);
                setUserData([...userData]);
                toastify({title: 'Changes Applied', message: 'User edited successfully', isSuccessful: true})
            }
            onModalClose();
        } catch (errInfo) {
            console.log(errInfo);
        }
    };

    const handleFormInput = (value: any, type: any) => {
        if (type === 'roles') {
            setIsFormEmpty(false);
        } else {
            form.setFieldValue(type, value);
            setIsFormEmpty(false);
        }
    }

    const resetForm = () => {
        form.resetFields(['roles', 'email', 'firstName', 'middleName', 'lastName', 'employeeId']);
        setIsFormEmpty(true);
    }

    return (
        <div className="data-table">
            <Form
                form={form}
                initialValues={{
                    ...initialData,
                    roles: mode === 'create'
                        ? [User_type.EMPLOYEE]   // <-- Default selected
                        : initialData?.roles || []
                }}

                name="basic"
                labelCol={{span: 8}}
                wrapperCol={{span: 16}}
                onFinish={onFinish}
                autoComplete="off"
                className={'user-create-section'}
                disabled={mode === 'view'}
            >
                <div className="user-create-form">
                    <Form.Item
                        className={'user-create-form-field'}
                        label={tempResources.firstNameLabel}
                        name={tempResources.firstNameName}
                        rules={[
                            {required: true, message: `${tempResources.firstNameRequiredMessage}`},
                            {pattern: new RegExp("^[A-Za-z\\s]+$"), message: tempResources.firstNameMessage},
                        ]}
                    >
                        <Input
                            placeholder="Enter first name"
                            onChange={(e) => handleFormInput(e.target.value, 'firstName')}

                        />
                    </Form.Item>
                    <Form.Item
                        label={tempResources.middleNameLabel}
                        name={tempResources.middleNameName}
                        className={"user-create-form-field middle-name"}
                        rules={[
                            {pattern: new RegExp("^[A-Za-z\\s]+$"), message: `${tempResources.middleNameMessage}`},
                        ]}
                    >
                        <Input
                            placeholder="Enter middle name"
                            onChange={(e) => handleFormInput(e.target.value, 'middleName')}
                        />
                    </Form.Item>

                    <Form.Item
                        label={tempResources.lastNameLabel}
                        name={tempResources.lastNameName}
                        className={"user-create-form-field last-name"}
                        required={true}
                        rules={[
                            {required: true, message: tempResources.lastNameRequiredMessage},
                            {pattern: new RegExp("^[A-Za-z\\s]+$"), message: tempResources.lastNameMessage},
                        ]}>
                        <Input
                            placeholder="Enter last name"
                            onChange={(e) => handleFormInput(e.target.value, 'lastName')}
                            className={'user-create-input'}
                        />
                    </Form.Item>
                    <Form.Item
                        label={tempResources.emailLabel}
                        name={tempResources.emailName}
                        rules={[
                            {required: true, message: tempResources.emailRequiredMessage},
                            {
                                pattern: new RegExp(
                                    /^(([^<>()[\]\\.,;:\s@]+(\.[^<>()[\]\\.,;:\s@]+)*)|(.+))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                                ),
                                message: tempResources.emailMessage,
                            },
                        ]}
                        className={"user-create-form-field"}
                    >
                        <Input
                            placeholder="Enter email"
                            onChange={(e) => handleFormInput(e.target.value, 'email')}
                        />
                    </Form.Item>
                    <Form.Item
                        label={tempResources.rolesLabel}
                        name={tempResources.rolesName}
                        className={"user-create-form-field select-role"}
                        required={true}
                        rules={[
                            {
                                required: true,
                                message: tempResources.rolesRequiredMessage,
                            },
                        ]}
                    >
                        <Select
                            placeholder={tempResources.rolesPlaceholder}
                            mode="multiple"
                            onSelect={(e) => handleFormInput(e, 'roles')}

                        >
                            {userTypesEnum.map((userType) => (
                                <Select.Option key={userType} value={userType}>
                                    {userType.toString()}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                </div>
                {mode !== 'view' && (
                    <div className={'user-form-button'}>
                        <Button disabled={isFormEmpty} type="primary" htmlType="submit">
                            {mode === 'create' ? tempResourcesButton.createButton : tempResourcesButton.updateButton}
                        </Button>
                        <Button disabled={isFormEmpty} type="primary" onClick={resetForm}>
                            {tempResourcesButton.resetButton}
                        </Button>
                    </div>
                )}
            </Form>
        </div>
    );
};

export default UserCreate;